import { render } from "./PrincingCards.vue?vue&type=template&id=42774d2d"
import script from "./PrincingCards.vue?vue&type=script&lang=js"
export * from "./PrincingCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__